module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("编辑甄选享玩设置")])])], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "shopForm",
    attrs: {
      "model": _vm.shopForm,
      "rules": _vm.addShopRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "享玩甄选描述",
      "label-width": "150px",
      "prop": "description"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.shopForm.name),
      callback: function($$v) {
        _vm.$set(_vm.shopForm, "name", $$v)
      },
      expression: "shopForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品选择",
      "label-width": "150px"
    }
  }, [_c('el-select', {
    on: {
      "change": _vm.productChoose
    },
    model: {
      value: (_vm.shopForm.shop),
      callback: function($$v) {
        _vm.$set(_vm.shopForm, "shop", $$v)
      },
      expression: "shopForm.shop"
    }
  }, _vm._l((_vm.productArr), function(item) {
    return (item.isOnline) ? _c('el-option', {
      key: item.productDetailId,
      attrs: {
        "label": item.name,
        "value": item.productDetailId
      }
    }) : _vm._e()
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "当前租金(元)",
      "label-width": "150px"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.shopForm.product.rental),
      callback: function($$v) {
        _vm.$set(_vm.shopForm.product, "rental", $$v)
      },
      expression: "shopForm.product.rental"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "原租金(元)",
      "label-width": "150px",
      "prop": "oldRental"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.shopForm.product.oldRental),
      callback: function($$v) {
        _vm.$set(_vm.shopForm.product, "oldRental", $$v)
      },
      expression: "shopForm.product.oldRental"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "150px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-db029daa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/nav1/EditShop.vue
// module id = 757
// module chunks = 1